module.exports = __webpack_public_path__ + "static/img/品牌banner.c384bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/新建文件夹/品牌banner.png
// module id = SNpL
// module chunks = 192